// ----------------------------------------------------------------------
// <copyright file="Izenda.AffixContainer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var EdgeDetector = require('share/components/controls/Izenda.EdgeDetector');
  var Utils = require('share/utils/Izenda.DomUtils');
  var requestAnimationFrame = require('dom-helpers/util/requestAnimationFrame');
  var clazz = require('dom-helpers/class');
  var style = require('dom-helpers/style');
  var removeStyle = require('dom-helpers/style/removeStyle');
  var offset = require('dom-helpers/query/offset');
  const { isNil } = require('lodash/fp');

  var AffixContainer = React.createClass({
    propTypes: {
      affixClass: React.PropTypes.string,
      getAffix: React.PropTypes.func.isRequired,
      onAffix: React.PropTypes.func
    },
    componentDidMount: function() {
      this.listen();
    },
    componentWillUnmount: function() {
      this.unlisten();
    },
    render: function() {
      return (
        <EdgeDetector className={this.props.className} onChanged={this.onAffixChanged}>
          <div ref="spaceDiv" style={{ height: '0px' }} />
          {this.props.children}
        </EdgeDetector>
      );
    },
    /**
     * Listen to scroll and resize event to update affix position accordingly
     */
    listen: function() {
      var onScroll = function() {
        this.onAffixChanged(null);
      }.bind(this);

      var affix = this.props.getAffix();
      var scrollableAncestor = Utils.findScrollableParent(affix);

      scrollableAncestor && scrollableAncestor.addEventListener('scroll', onScroll, { passive: true });

      this.unlisten = function() {
        scrollableAncestor && scrollableAncestor.removeEventListener('scroll', onScroll, { passive: true });
      };
    },
    /**
     * Notify affix changed (its positions)
     */
    onAffixChanged: function(onEdge) {
      if (isNil(onEdge)) {
        this.update(this.onEdge, false);
      } else {
        this.onEdge = onEdge;

        if (this.rafCancelId) {
          requestAnimationFrame.cancel(this.rafCancelId);
        }
        this.rafCancelId = requestAnimationFrame(
          function() {
            this.update(this.onEdge, true);
          }.bind(this)
        );
      }
    },
    /**
     * Update affix element position
     */
    update: function(onEdge, isLast) {
      var affix = this.props.getAffix();
      if (!affix) {
        return;
      }

      var scrollableAncestor = Utils.findScrollableParent(affix);
      var positioning = onEdge ? 'absolute' : 'static';
      var affixOffset = offset(affix);
      var spaceDiv = this.refs.spaceDiv;

      this.scrollTop = scrollableAncestor ? scrollableAncestor.scrollTop : 0;

      if (onEdge) {
        this.lastOffset = affixOffset;

        style(affix, {
          position: positioning,
          width: '100%',
          zIndex: 1,
          top: (this.scrollTop || 0) + 'px'
        });
        clazz.addClass(affix, this.props.affixClass || 'affix');
        style(spaceDiv, {
          height: affixOffset.height + 'px'
        });

        this.props.onAffix && this.props.onAffix(isLast);
      } else if (this.lastOffset) {
        removeStyle(affix, 'width');
        removeStyle(affix, 'z-index');
        style(affix, {
          position: positioning,
          top: this.lastOffset.top + 'px'
        });

        clazz.removeClass(affix, this.props.affixClass || 'affix');
        style(spaceDiv, {
          height: '0px'
        });
      }
    }
  });

  module.exports = AffixContainer;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.AffixContainer.jsx